import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@bitsandflames/web-components/theme";
import "@bitsandflames/web-components/styles.css";
import "./styles.css";
import App from "./App";
createRoot(document.getElementById("root")!).render(
  <ThemeProvider>
    <App />
  </ThemeProvider>,
);
